import { useStoreSelector } from "../../../../src/lib/store";
import { uiStore } from "../store/uiStore";

/** Bottom status strip. Message + visibility from `uiStore`. */
export function StatusBar() {
  const open = useStoreSelector(uiStore, s => s.statusOpen);
  const message = useStoreSelector(uiStore, s => s.statusMessage);

  if (!open) {
    return null;
  }

  return (
    <div
      className="status shrink-0 whitespace-pre-wrap rounded-md border border-lab-line bg-lab-panel px-[0.7rem] py-[0.45rem] text-[12px] text-lab-muted"
      id="status"
      role="status"
      aria-live="polite"
    >
      {message}
    </div>
  );
}
